module.exports = __webpack_public_path__ + "static/media/travel.dbad635a.png";